import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Slider from "@components/sections/slider"
import BannerTop from "@components/sections/bannerTop"
import BannerBottom from "@components/sections/bannerBottom"
import Portfolio from "@components/sections/portfolio"
import Contact from "@components/sections/contact"
import Customers from "@components/sections/customers"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`Lukas`, `Gabriel`, `Production`]} />

    <section id="sidler">
      <Slider />
    </section>
    <section>
      <BannerTop />
    </section>
    <section id="realizacje">
      <Portfolio />
    </section>
    <section id="zaufali-nam">
      <Customers />
    </section>
    <section>
      <BannerBottom />
    </section>
    <section id="kontakt">
      <Contact />
    </section>
  </Layout>
)

export default IndexPage
